import gql from 'graphql-tag';
import { FRAGMENT_HERO } from 'src/modules/layout/components/block/hero/queries';
// import { referencesToLoad, referencesPerPage, filteredReferencesPerPage } from '../store/types';

export const FRAGMENT_REFERENCE_DETAILS = gql`
  fragment referenceCardFields on Reference {
    name
    reference_category {
      id
      name_en
      name_de
    }
    location_types {
      id
    }
    article {
      slug
      hero {
        ...hero
      }
    }
  }
  ${FRAGMENT_HERO}
`;

export const QUERY_REFERENCES_LISTING = gql`
  query References(
    $start: Int! = 0
    $limit: Int! = 0
    $categories: [ID!]! = []
    $countries: [ID!]! = []
    $locationTypes: [ID!]! = []
  ) {
    references(
      where: {
        # channels_in: ["en_US", "de_DE", "en_AU"]
        article_null: false
        reference_category_in: $categories
        country_in: $countries
        location_types_in: $locationTypes
      }
      limit: $limit
      start: $start
      sort: "published_at:desc"
    ) {
      ...referenceCardFields
    }
  }
  ${FRAGMENT_REFERENCE_DETAILS}
`;

export const QUERY_REFERENCES_LISTING_FILTERS = gql`
  query ReferenceFilters {
    referenceCategories {
      id
      name_en
      name_de
    }
    countries: countriesWithReference {
      id
      name_en
      name_de
    }
    locationTypes(where: { pim_key_null: false }) {
      id
      name_en
      name_de
    }
  }
`;

export const QUERY_REFERENCES_LISTING_COUNT = gql`
  query ReferenceCount(
    $categories: [ID!]! = []
    $countries: [ID!]! = []
    $locationTypes: [ID!]! = []
  ) {
    referencesCount(
      where: {
        reference_categories: $categories
        countries: $countries
        location_types: $locationTypes
      }
    )
  }
`;
